import { makeSimpleMapper } from "@/core/acl/mapperFactory";
import { zClientSchemaDom, zClientSchemaCreateDom, } from "@/types/client/client.domain";
import { zClientSchemaDto, zClientSchemaCreateDto, } from "@/types/client/client.dto";
export const ClientMapper = makeSimpleMapper({
    dtoToDomain: (dto) => zClientSchemaDom.parse(dto),
    domainToDto: (domain) => zClientSchemaDto.parse(domain),
    dtoToCreateDto: (domain) => zClientSchemaCreateDto.parse(domain),
    dtoToCreateDom: (dto) => zClientSchemaCreateDom.parse(dto),
});
